/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Freight_OutInputs */

const en_setup_freight_out = /** @type {(inputs: Setup_Freight_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freight out`)
};

/**
* | output |
* | --- |
* | "Freight out" |
*
* @param {Setup_Freight_OutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_freight_out = /** @type {((inputs?: Setup_Freight_OutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Freight_OutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_freight_out(inputs)
});